import axios from 'axios'
import { getOfflineCustomers, setOfflineCustomers } from '@/forage/shared/customers'
import misc from '@/mixins/misc'

const CustomerService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    if (navigator.onLine) {
      return axios.get('admin/customers', { params }).then(
        response => {
          if (misc.methods.isMobile()) {
            setOfflineCustomers(response.data.items)
          }
          return response
        }
      )
    }

    const items = await getOfflineCustomers(params)
    // console.log('Offline', items, params)

    return {
      data: {
        current_page: 1,
        items: items,
        per_page: 10,
        total_rows: items.length
      }
    }
  },

  async import (params = {}) {
    return axios.post('admin/utilities/import-customers', params)
  },

  async sync (params = {}) {
    return axios.post('admin/utilities/sync-customers', params)
  },

  async show (id) {
    return axios.get(`admin/customers/${id}`)
  },

  async post (params = {}) {
    return axios.post('admin/customers', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/customers/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/customers/${data.id}`, { data })
  }
}

export default CustomerService
